"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROL_CHARACTER_REGEX = void 0;
// List of Control Characters for reference
// https://www.compart.com/en/unicode/category/Cc
// Some characters are skipped due to use in normal text editing (ex: tab, new line),
// eslint-disable-next-line no-control-regex
exports.CONTROL_CHARACTER_REGEX = /[\u0000-\u0008\u000E-\u001F\u007F-\u0084\u0086-\u009F]/g;
